import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

export const videocamIconWrapper = (isClickable?: boolean) => css`
  border-radius: 100%;
  background-color: ${colors.gray.lightest};
  position: relative;
  display: flex;
  width: ${icons.size.large};
  height: ${icons.size.large};
  min-width: ${icons.size.large};
  min-height: ${icons.size.large};
  align-items: center;
  justify-content: center;
  cursor: ${isClickable ? 'pointer' : 'default'};

  > svg {
    width: ${icons.size.small};
    height: ${icons.size.small};
    color: ${colors.gray.dark};
  }
`;

export const popperBodyText = css`
  margin-top: 10px;
`;
